import { createIcon } from './create-icon'

export const ChevronUp = createIcon({
  displayName: 'ChevronUp',
  paths: [
    'M810.688 640.026c0 10.453-3.797 20.949-11.563 29.184-16.085 17.195-43.093 18.048-60.288 1.92l-241.877-226.731-209.749 224.725c-16.085 17.237-43.051 18.176-60.288 2.091-17.28-16.085-18.176-43.136-2.091-60.288l238.933-256.001c7.723-8.277 18.432-13.184 29.739-13.568 11.349-0.341 22.357 3.797 30.635 11.563l273.067 256.001c8.96 8.363 13.483 19.712 13.483 31.104z'
  ]
})
